import { useWatch } from 'antd/es/form/Form'
import type { FormInstance } from 'antd/lib'
import { useEffect, useRef } from 'react'

export const useUpdateKeyWorkers = ({
  form,
  enabled = false
}: {
  form?: FormInstance<any>
  enabled?: boolean
}) => {
  const keyworkers = useWatch('keyworkers', form) || []

  const assignedCarers = useWatch('carers', form) || []

  const assignAll = useWatch('assignAll', form)

  const hasTouchedCarers = form?.isFieldTouched('carers')

  const prevAssignedCarersRef = useRef(assignedCarers)

  useEffect(() => {
    if (
      enabled === true &&
      assignAll === false &&
      hasTouchedCarers &&
      assignedCarers?.length < prevAssignedCarersRef?.current?.length
    ) {
      form?.setFieldValue(
        'keyworkers',
        keyworkers?.filter((item: string) => assignedCarers?.includes(item))
      )
    }

    prevAssignedCarersRef.current = assignedCarers
  }, [assignedCarers, assignAll, prevAssignedCarersRef])
}
